function CircleButton({ label, icon, onClick, ariaLabel, className = '', disabled = false }) {
  return (
    <button
      type="button"
      className={`circleButton ${className}`.trim()}
      onClick={onClick}
      aria-label={ariaLabel || (typeof label === 'string' ? label : undefined)}
      disabled={disabled}
    >
      <span className="circleButton__label">{label}</span>
      {icon ? <span className="circleButton__icon">{icon}</span> : null}
    </button>
  );
}

export default CircleButton;
